import { render } from "./VideosSection.vue?vue&type=template&id=20227d5e&scoped=true"
import script from "./VideosSection.vue?vue&type=script&lang=js"
export * from "./VideosSection.vue?vue&type=script&lang=js"

import "./VideosSection.vue?vue&type=style&index=0&id=20227d5e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20227d5e"]])

export default __exports__